import { useFormikContext } from 'formik';
import { KeyboardEvent, useContext, useEffect, useRef } from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { OctNumberField } from '@oceantech/oceantech-ui';
import TextField from '../../../../../component/TextField';
import { useKeVatTuContext } from '../../context';
import { getDrugDetailById } from '../../../../services/ThuocService';
import { AppContext } from '../../../../../appContext/AppContext';

type Props = {
	data: any;
	onSave: (value: any) => void;
};

const TableSelectVatTuRowEdit = ({ data, onSave }: Props) => {
	const { values, setValues, setFieldValue } = useFormikContext<any>();
	const { treeValue, treeNodeValue } = useKeVatTuContext();
	const { setIsLoading } = useContext(AppContext);
	
	const soLuongInputRef = useRef<HTMLInputElement>(null);

	useEffect(() => {
		getDetailVatTu(data);
	}, [data?.id, data?.consignment]);

	const getDetailVatTu = async (value: any) => {
		if (!value?.id) return;

		let vatTuDetail;

		if (treeNodeValue?.length) {
			vatTuDetail = treeNodeValue.find(
				(row) =>
					Number(row.id) === Number(value.idVatTu || value.id) &&
					row?.consignment === value?.consignment
			);
		} else {
			try {
				setIsLoading(true);
				const response = await getDrugDetailById((value.idVatTu || value.id), {
					warehouseId: treeValue.id,
					consignment: value.consignment,
					serialNumber: value.serialNumber,
				});

				vatTuDetail = response.data;
			} catch (error) {
				console.error(error);
			} finally {
				setIsLoading(false);
			}
		}

		setValues({
			...values,
			tenVatTu: value?.tenVatTu,
			donVi: value?.donVi,
			tonKho: vatTuDetail?.availableQuantity ??
				parseInt(vatTuDetail?.iventory || vatTuDetail?.tonKho) -
				parseInt(vatTuDetail?.peShipment || 0),
			soLuong: value?.soLuong,
		});

		if (soLuongInputRef.current) {
			soLuongInputRef.current.disabled = false;
			soLuongInputRef.current.focus();
		}
	};

	const onSaveRow = () => {
		if (!values?.soLuong) {
			toast.warn('Chưa nhập số lượng vật tư cần kê');
			return;
		}

		if (values.soLuong > values.tonKho) {
			toast.warn('Số lượng vật tư kê đơn không được lớn hơn số lượng vật tư khả dụng');
			return;
		}

		onSave({
			...data,
			tenVatTu: values.tenVatTu,
			donVi: values.donVi,
			tonKho: values.tonKho,
			soLuong: values.soLuong,
		});

		setValues({
			...values,
			tenVatTu: '',
			donVi: '',
			tonKho: 0,
			soLuong: 0,
		});
	};

	const onButtonSaveKeydown = (e: KeyboardEvent<HTMLButtonElement>) => {
		if (e.key === 'Enter') {
			onSaveRow();
		}
	};

	return (
		<Row onKeyDown={onButtonSaveKeydown}>
			<Col xs={4}>
				<TextField
					label="Tên vật tư:"
					className="spaces w-100"
					inputClassName="w-100"
					name="tenVatTu"
					labelClassName="ms-0 min-w-80px"
					disabled
				/>
			</Col>
			<Col xs={2}>
				<TextField
					label="Đơn vị:"
					className="spaces w-100"
					inputClassName="w-100"
					name="donVi"
					labelClassName="ms-0 min-w-60px"
					disabled
				/>
			</Col>
			<Col xs={2}>
				<OctNumberField
					label="SL khả dụng:"
					className="spaces w-100"
					inputClassName="w-100"
					name="tonKho"
					labelClassName="spaces ms-0 min-w-95"
					value={values?.tonKho}
					disabled
				/>
			</Col>
			<Col xs={2}>
				<OctNumberField
					label="Số lượng:"
					className="spaces w-100"
					inputClassName="w-100"
					name="soLuong"
					labelClassName="ms-0 min-w-70px"
					disabled={!values?.tenVatTu}
					inputRef={soLuongInputRef}
					value={values?.soLuong}
					onChange={(	value: number) => {
						setFieldValue('soLuong', value);
					}}
				/>
			</Col>
			<Col xs={2}>
				<Button className="btn-fill" onClick={onSaveRow} disabled={!values?.tenVatTu}>
					<i className="bi bi-check-lg"></i>Xác nhận
				</Button>
			</Col>
		</Row>
	);
};

export default TableSelectVatTuRowEdit;
